// for payroll history  of employee
export const RESER_PAYROLL_PAYMENT_HISTORY = "resign_payroll_payment_history";
export const PAYROLL_PAYMENT_HISTORY = "payroll_payment_history";
export const PAYROLL_PAYMENT_HISTORY_SUCCESS =
    "payroll_payment_history_success";
export const PAYROLL_PAYMENT_HISTORY_FAILURE =
    "payroll_payment_history_failure";
